import { Component, Element, Host, h, Prop } from '@stencil/core';
import { attachSlottedCss } from '../../utils';
import { getSlottedCss } from './image-styles';
import { TImageObjectFit, TImageStyle } from './image-utils';

@Component({
  tag: 'dc-ui-image-wrapper',
  styleUrl: 'dc-ui-image-wrapper.scss',
  shadow: true,
})
export class DcUiImageWrapper {
  @Element() el: HTMLElement;
  @Prop() imageStyle: TImageStyle;
  @Prop() objectFit: TImageObjectFit;
  @Prop() ratio?: string;
  @Prop() hoverScale?: boolean;

  connectedCallback() {
    attachSlottedCss(
      this.el,
      getSlottedCss(this.el, this.ratio, this.imageStyle, this.objectFit),
    );
  }

  private readonly returnCSSClasses = () => {
    return {
      'dc-ui-image-wrapper': true,
      'dc-ui-image-wrapper--hover-scale': !!this.hoverScale,
    };
  };

  render() {
    return (
      <Host>
        <div class={this.returnCSSClasses()}>
          <slot />
        </div>
      </Host>
    );
  }
}
